import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { _ as _slicedToArray } from '../slicedToArray-a6a95674.js';
import { useState, useCallback, useEffect } from 'react';
import { useAuthContext } from '@picsart/growth-rc/AuthContext';
import { u as useCheckoutModalContext } from '../CheckoutModalContext-fa8f6d02.js';
import { CREDIT_TOOL_ID, fetchCredits } from '../creditsService/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useCreditsInfo(_ref) {
  var checkoutGtmData = _ref.checkoutGtmData;
  var _useAuthContext = useAuthContext(),
    user = _useAuthContext.user,
    tokenDataRef = _useAuthContext.tokenDataRef;
  var _useCheckoutModalCont = useCheckoutModalContext(),
    setIsOpen = _useCheckoutModalCont.setIsOpen,
    userSubscription = _useCheckoutModalCont.userSubscription;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    creditsInfo = _useState2[0],
    setCreditsInfo = _useState2[1];
  var handleButtonClick = useCallback(function () {
    setIsOpen(true, {
      gtmData: _objectSpread({
        action_button: 'profile_credits'
      }, checkoutGtmData),
      toolId: CREDIT_TOOL_ID
    });
  }, [checkoutGtmData, setIsOpen]);
  useEffect(function () {
    var _tokenDataRef$current, _tokenDataRef$current2;
    if (!user || !(tokenDataRef !== null && tokenDataRef !== void 0 && (_tokenDataRef$current = tokenDataRef.current) !== null && _tokenDataRef$current !== void 0 && _tokenDataRef$current.access_token)) {
      setCreditsInfo(undefined);
      return;
    }

    // check if availability call is needed or not
    fetchCredits(tokenDataRef === null || tokenDataRef === void 0 || (_tokenDataRef$current2 = tokenDataRef.current) === null || _tokenDataRef$current2 === void 0 ? void 0 : _tokenDataRef$current2.access_token).then(function (_ref2) {
      var status = _ref2.status,
        response = _ref2.response;
      if (status === 'success' && response) {
        setCreditsInfo(response);
      }
    })["catch"](function () {
      setCreditsInfo(undefined);
    });
  }, [tokenDataRef, user, userSubscription]);
  return {
    handleButtonClick: handleButtonClick,
    creditsInfo: creditsInfo
  };
}

export { useCreditsInfo as default };
//# sourceMappingURL=index.js.map
